import React, {Component} from 'react'
import {Row, Col} from 'antd';
export default class ImportBoxInfoView extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    showSealNo = (newSealNo, sealNo) => {
        if (newSealNo !== undefined && newSealNo != null){
            return newSealNo;
        }
        return sealNo;
    };

    render() {
        const {entrustType, boxInfo} = this.props;
        return (<Row className='box-info'>
                <Col span={6}>
                    <span className='label'>铅封号：</span>
                    <span>{this.showSealNo(boxInfo.newSealNo, boxInfo.sealNo)}</span>
                </Col>
                <Col span={6}>
                    <span className='label'>过磅重量(KG)：</span>
                    <span>{boxInfo.weigh}</span>
                </Col>
                {entrustType === 'p2w' ?
                    <Col span={6}>
                        <span className='label'>预计抵达时间：</span>
                        <span>{boxInfo.estimateArriveDt}</span>
                    </Col>
                : null}
            </Row>
        )
    }
}